import PropTypes from 'prop-types'
import { Progress } from '@components/ui/progress'
import { cn } from 'lib/utils'

const colorClass = {
  primary: '[&>div]:bg-primary',
  success: '[&>div]:bg-success',
  error: '[&>div]:bg-error',
  warning: '[&>div]:bg-warning',
  secondary: '[&>div]:bg-secondary'
}

export const AdasLinearProgress = ({ value, variant = 'indeterminate', color = 'primary', className, sx, ...props }) => {
  if (variant === 'indeterminate') {
    return (
      <div className={cn('w-full h-1 overflow-hidden rounded-full bg-primary/20', className)}>
        <div className='h-full w-1/3 bg-primary animate-indeterminate rounded-full' />
      </div>
    )
  }
  return <Progress value={value} className={cn('h-1', colorClass[color] ?? '[&>div]:bg-primary', className)} {...props} />
}

AdasLinearProgress.propTypes = { value: PropTypes.number, variant: PropTypes.string, color: PropTypes.string, className: PropTypes.string }
